const ThreatImage: React.FC<{ bgNumber: number; elNumber: number }> = ({
  bgNumber,
  elNumber,
}) => {
  return (
    <div className="relative h-[320px] w-[320px]">
      <img
        src={`/images/threat-generation/background-${bgNumber}.png`}
        className="absolute top-0 left-0 h-[320px] w-[320px]"
      />
      <img
        src={"/images/threat-generation/particles_animation.svg"}
        className="absolute top-[10px] left-[10px] h-[300px] w-[300px]"
      />
      <img
        src={`/images/threat-generation/element-${elNumber}.png`}
        className="absolute top-0 left-0 h-[200px] w-[200px]"
      />
    </div>
  );
};

export default ThreatImage;
